var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_474",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_474)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.31 17.89L21.71 19.29C22.1 19.68 22.1 20.32 21.71 20.71C21.51 20.9 21.26 21 21 21C20.74 21 20.49 20.9 20.29 20.71L18.89 19.31C18.2 19.75 17.38 20 16.5 20C14.54 20 12.87 18.75 12.26 17C12.09 16.53 12 16.03 12 15.5C12 13.01 14.01 11 16.5 11C17.42 11 18.28 11.28 19 11.76C20.21 12.56 21 13.94 21 15.5C21 16.38 20.75 17.2 20.31 17.89ZM14.5 17C14.96 17.61 15.68 18 16.5 18C16.82 18 17.13 17.94 17.41 17.83C17.99 17.6 18.46 17.16 18.74 16.61C18.79 16.56 18.83 16.49 18.85 16.43C18.95 16.27 19 16.09 19 15.9V15.5C19 14.12 17.88 13 16.5 13C15.12 13 14 14.12 14 15.5C14 16.06 14.19 16.59 14.5 17ZM18.83 16.41L18.83 16.41C18.94 16.13 19 15.82 19 15.5V15.9C19 16.09 18.95 16.27 18.85 16.43C18.83 16.49 18.79 16.56 18.74 16.61C18.77 16.55 18.8 16.48 18.83 16.41Z",
    fill: "#1E9B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 3H3.1C2.49 3 2 3.49 2 4.1V15.9C2 16.51 2.49 17 3.1 17H11.21C11.07 16.52 11 16.02 11 15.5C11 12.46 13.46 10 16.5 10C17.4 10 18.25 10.22 19 10.61V4.1C19 3.49 18.51 3 17.9 3ZM14.71 8.84L11.74 11.32C11.44 11.57 10.99 11.57 10.69 11.32L9.03 9.93L7.34 11.34C7.19 11.47 7 11.53 6.82 11.53C6.59 11.53 6.35 11.43 6.19 11.24C5.9 10.89 5.95 10.38 6.29 10.09L8.5 8.24C8.8 7.99 9.25 7.99 9.55 8.24L11.21 9.63L13.65 7.59C14 7.3 14.51 7.35 14.8 7.69C15.09 8.04 15.04 8.55 14.7 8.84H14.71Z",
    fill: "#1E9B6B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceOn);
export default __webpack_public_path__ + "static/media/price_on.06e4a386e6340aaf8fd625530f25ed37.svg";
export { ForwardRef as ReactComponent };